import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout for /users/:id/* — hosts the view (index) and edit child routes.
export const Route = createFileRoute('/_authenticated/users/$id')({
  component: () => <Outlet />,
});
